import {
  BlockingWidgetDisplayMode,
  CopilotWidgetType,
} from 'common/src/modules/shared/copilot/copilot.enums';
import {SupportSkillToolName} from '../../supportSkill.enums';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import convertToZendeskSupportForm from './utils/convertToZendeskSupportForm';
import {launchSupportFormInputSchema} from './launchSupportFormTool.schemas';

function launchSupportFormTool() {
  async function execute({
    input,
    toolUtils,
  }: ToolExecuteParams<typeof launchSupportFormInputSchema>): Promise<ToolResult> {
    const form = convertToZendeskSupportForm(input);

    const result = await toolUtils.requestUserFeedback({
      displayMode: BlockingWidgetDisplayMode.Inline,
      widget: {
        type: CopilotWidgetType.SupportTicketWidget,
        content: form,
      },
    });

    return toolResult(result);
  }

  return tool({
    name: SupportSkillToolName.LaunchSupportForm,
    displayName: 'Submitting support ticket',
    description:
      'Submit a support ticket with the collected information. The conversation history will be attached automatically. The user can attach up to 4 files (e.g. screenshots, logs) through the form. Let the user know about this before calling the tool.',
    inputSchema: launchSupportFormInputSchema,
    execute,
  });
}

export default launchSupportFormTool;
